import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import '../src/index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';


import { Provider } from 'react-redux';
import { store } from './redux/store';
import axios from 'axios';

// Intercept all axios requests to rewrite hardcoded production URLs with REACT_APP_API_URL if configured
axios.interceptors.request.use((config) => {
  const apiBase = process.env.REACT_APP_API_URL;
  if (apiBase && config.url) {
    if (config.url.startsWith('https://api.dailyfit.ae')) {
      config.url = config.url.replace('https://api.dailyfit.ae', apiBase);
    } else if (config.url.startsWith('http://3.27.235.199')) {
      config.url = config.url.replace('http://3.27.235.199', apiBase);
    }
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
